module.exports = __webpack_public_path__ + "static/media/All_Products_1440x961.dc2d51af.jpg";